export const SPECIALIST_API = {
  GET_CLINIC_HOME_PAGE: 'composite-portal/1.0/consult_home',
  GET_DETAIL: 'doctor/3.0/doctor_detail',
  FOLLOW: 'doctor/3.0/follow_doctor',
  UNFOLLOW: 'doctor/3.0/unfollow_doctor',
  GET_CLOUD_COIN: 'coin_info',
  SEARCH_DOCTORS: 'search/1.0/keyword_doctor_search',
  GET_REGION: 'spider-district/1.0/child',
  GET_HOT_CITY: 'doctor/3.0/hot_city',
  GET_FOLLOW_SPECIALIST_LIST: 'doctor/3.0/follow_doctor_list',
  GET_DEPARTMENTS: 'marking_department/2.0/get_unhide_marking_department_list',
  GET_FILTER_CONDITIONS: 'doctor/3.0/doctor_search_conditions',
  PAY_CONSULT: 'consult/3.0/pay_consult',
  START_CONSULT: 'consult/3.0/start_consult',

  GET_RECOMMEND_SPECIALIST: 'doctor/3.0/recommend_famous_doctors',
  DEPARTMENT_DOCTOR_SEARCH: 'search/1.0/department_doctor_search',
  GET_IM_RECOMMEND_SPECIALIST: 'consult/3.0/recommend_doctor_list',
  GET_LOCATION: 'mall-portal/1.0/get_location_city',
  GET_HOSPITALS_TYPE: 'doctor/1.0/hospital_type_list',
  GET_HOSPITAL_LIST: 'doctor/1.0/query_hospital_list',
  GET_HOSPITAL_DEPT_SPECIALIST: '/search/1.0/hospital_doctor_search',
  GET_HOSPITAL_DETAIL: 'doctor/1.0/query_hospital_detail',
  GET_HOSPITAL_DEPARTMENTS: 'search/1.0/get_department_marking',
  GET_COIN_RECHARGE_INFO: 'consult/1.0/coin_recharge_info',
  GROUP_DOCTOR_SEARCH: 'search/1.0/doctor_group_type_search',
  // TODO change api
  PLACE_ORDER: 'consult/3.0/start_consult',

  GET_SPECIALIST_PACKS: 'disease-api/1.0.0/get_doctor_packs',
  GET_SPECIALIST_PAID_PACKS: 'operation-portal/1.0/gePackList',
  GET_EQUITY_PACK_DETAIL: 'operation-portal/1.0/get_pack_detail',
  START_CONSULT_V2_1: 'consult/2.1/start_consult'
};

export const FAST_INQUIRY_API = {
  CANCEL_CONSULT: 'consult/3.0/cancel_consult',
  PAY_CONSULT: 'consult/3.0/pay_quick_consult',
  GET_PAY_INFO: 'consult/3.0/query_quick_consult_status',
  // TODO change api
  PLACE_ORDER: 'consult/3.0/start_quick_consult'
};

export const USER_API = {
  CHECK_IM_ACTIVITY: 'consult/3.0/im_entrance_check'
};

export const ADDRESS_API = {
  GET_LOCATION: 'mall-portal/1.0/get_location_city'
};
